import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  Button,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 4 }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{ mb: 3, color: '#4338CA' }}
        >
          Ana Sayfaya Dön
        </Button>

        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#1e293b' }}>
            Gizlilik Politikası
          </Typography>
          
          <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </Typography>

          <Divider sx={{ mb: 4 }} />

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            1. Genel Bilgiler
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            LGSCİYİZ uygulaması, LGS'ye hazırlanan öğrencilere günlük sorular ve sıralama sistemi sunan 
            bir eğitim platformudur. Bu gizlilik politikası, kişisel verilerinizin nasıl toplandığını, 
            kullanıldığını ve korunduğunu açıklamaktadır.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            2. Toplanan Bilgiler
          </Typography>
          <List sx={{ mb: 4 }}>
            <ListItem>
              <ListItemText 
                primary="Hesap Bilgileri"
                secondary="Ad, soyad, e-posta adresi, sınıf bilgisi"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Eğitim Verileri"
                secondary="Çözülen sorular, doğru/yanlış cevaplar, performans istatistikleri"
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Teknik Bilgiler"
                secondary="Cihaz bilgileri, IP adresi, uygulama kullanım verileri"
              />
            </ListItem>
          </List>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            3. Verilerin Kullanımı
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            Toplanan veriler aşağıdaki amaçlarla kullanılır:
          </Typography>
          <List sx={{ mb: 4 }}>
            <ListItem>
              <ListItemText primary="Eğitim hizmetlerinin sunulması ve geliştirilmesi" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Kişiselleştirilmiş öğrenme deneyimi sağlanması" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Performans analizi ve sıralama sistemi" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Teknik destek ve müşteri hizmetleri" />
            </ListItem>
          </List>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            4. Veri Güvenliği
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            Kişisel verileriniz, endüstri standardı güvenlik önlemleri ile korunmaktadır. 
            Veriler şifrelenmiş olarak saklanır ve yetkisiz erişime karşı korunur.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            5. Üçüncü Taraflarla Paylaşım
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz. 
            Analitik ve teknik hizmetler için anonim veriler kullanılabilir.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            6. Çerezler (Cookies)
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            Uygulama deneyimini iyileştirmek için çerezler kullanılmaktadır. 
            Bu çerezler, oturum yönetimi ve kullanıcı tercihlerinin saklanması için gereklidir.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            7. Kullanıcı Hakları
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#4b5563' }}>
            KVKK kapsamında aşağıdaki haklara sahipsiniz:
          </Typography>
          <List sx={{ mb: 4 }}>
            <ListItem>
              <ListItemText primary="Kişisel verilerinizin işlenip işlenmediğini öğrenme" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Kişisel verilerinizin düzeltilmesini isteme" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Kişisel verilerinizin silinmesini isteme" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Veri işlemeye itiraz etme" />
            </ListItem>
          </List>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#374151' }}>
            8. İletişim
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, color: '#4b5563' }}>
            Gizlilik politikası ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
          </Typography>
          <Box sx={{ 
            p: 3, 
            backgroundColor: '#f1f5f9', 
            borderRadius: 2, 
            border: '1px solid #e2e8f0' 
          }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>E-posta:</strong> fikirlerfikirler@gmail.com
            </Typography>
            <Typography variant="body2">
              <strong>Adres:</strong> Türkiye
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body2" sx={{ color: '#64748b', textAlign: 'center' }}>
            Bu gizlilik politikası, yasal değişiklikler veya hizmet güncellemeleri durumunda 
            revize edilebilir. Güncellemeler bu sayfada yayınlanacaktır.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;